/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Or_CommandInputs */

const en_search_or_command = /** @type {(inputs: Search_Or_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search or run…`)
};

/**
* | output |
* | --- |
* | "Search or run…" |
*
* @param {Search_Or_CommandInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_or_command = /** @type {((inputs?: Search_Or_CommandInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Or_CommandInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_or_command(inputs)
});